import { useEffect, useState } from 'react';
import './styles.scss';

function ImageLoading({ src, alt, lowSrc = '', className = '', ...props }) {
    const [aspectRatio, setAspectRatio] = useState(null);
    const [loaded, setLoaded] = useState(false);

    const getImageSize = (url) => {
        return new Promise((resolve) => {
            const img = new Image();
            img.src = url;
            img.onload = () => {
                resolve({ width: img.naturalWidth, height: img.naturalHeight });
            };
        });
    };

    useEffect(() => {
        if (typeof window !== 'undefined' && lowSrc) {
            getImageSize(lowSrc).then(({ width, height }) => {
                setAspectRatio(`${width} / ${height}`);
            });
        }
    }, []);

    return (
        <>
            {!loaded && (
                <div
                    style={{
                        backgroundImage: lowSrc ? `url(${lowSrc})` : 'none',
                        aspectRatio: `${aspectRatio}`,
                        opacity: aspectRatio ? 1 : 0,
                    }}
                    className='blurred-img'
                >
                    <img
                        loading='lazy'
                        src={src}
                        alt={alt}
                        className={`${className} opacity-0`}
                        onLoad={(e) => {
                            e.target.classList.remove('opacity-0');
                            setLoaded(true);
                        }}
                    />
                </div>
            )}
            {loaded && (
                <img
                    {...props}
                    loading='lazy'
                    src={src}
                    alt={alt}
                    className={`${className}`}
                />
            )}
        </>
    );
}

export default ImageLoading;
